import { render } from "./FormEditGoals.vue?vue&type=template&id=05d816a8&scoped=true"
import script from "./FormEditGoals.vue?vue&type=script&lang=js"
export * from "./FormEditGoals.vue?vue&type=script&lang=js"

import "./FormEditGoals.vue?vue&type=style&index=0&id=05d816a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d816a8"]])

export default __exports__